export default "__VITE_PUBLIC_ASSET__5fafc5fb__"